


































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { queryList, download } from '@/api/report';
import moment from 'moment';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import { searchByName } from '@/api/common';
import { reportList } from '@/api/report';
import { permil } from '@/utils/finance';
import downloadStreamFile from '@/assets/js/downloadStreamFile';
import { mapGetters } from 'vuex';

const currencyMap = {
  0: '全部币种',
  1: '人民币',
  2: '美元',
  3: '人民币及美元'
};

@Component({
  components: {},
  computed: { ...mapGetters(['userInfo'])}
})
class INVESTPERFORMANCE extends Vue {
  userInfo: any;
  currencyList: any[] = [
    {
      name: '全部币种',
      value: 0
    },
    {
      name: '人民币',
      value: 1
    },
    {
      name: '美元',
      value: 2
    },
    {
      name: '人民币及美元',
      value: 3
    }
  ];
  currency: number = 0;
  // sectorList: any[] = [];
  NickNameList: any[] = [];
  columns: any[] = [];
  data: any[] = [];
  searchWord: string = '';
  nickName: string = '';
  endDate: string = '';
  page: number = 1;
  pageSize: number = 50;
  total: number = 0;
  current: number = 1;
  pageSizeOptions: any[] = ['10', '25', '50', '100', '200'];
  hasPermission: boolean = false;
  height: number = 0;

  mounted() {
    this.height = window.innerHeight - 400;
    window.onresize = () => {
      return (() => {
        this.height = window.innerHeight - 400;
      })();
    };
    this.getPermission();
    this.getSelects();
    this.getList();
    this.getColumns();
  }
  @Getter('token') token;

  async getSelects() {
    try {
      let res = await searchByName();
      if (res.code === 200) {
        this.NickNameList = res.data.list;
        this.NickNameList.unshift({ id: '', nickname: '全部项目负责人' });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getList() {
    try {
      let res = await queryList({
        page: this.page,
        pageSize: this.pageSize,
        projectName: this.searchWord,
        currency: this.currency,
        dlId: this.nickName,
        endDate: this.endDate
      });
      if (res.code === 200) {
        this.data = res.data.list;
        if (res.data.sum) {
          this.data.unshift({ auditDate: 'total', ...res.data.sum });
        }
        this.total = res.data.total;
      }
    } catch (err) {
      console.log(err);
    }
  }

  getColumns() {
    this.columns = [
      {
        title: '项目名称',
        fixed: 'left',
        customHeaderCell: (value, index) => {
          return {
            style: {
              'background-color': '#faf1d0'
            }
          };
        },
        children: [
          {
            title: '项目审核时间',
            dataIndex: 'auditDate',
            key: 'auditDate',
            width: '150px',
            align: 'center',
            // fixed: true,
            customRender: val => {
              if (val === 'total') {
                const obj = {
                  attrs: {}
                };
                obj.attrs['colSpan'] = 2;
                obj['children'] = <span style="font-weight:bold">合计</span>;
                return obj;
              }
              return val ? moment(val).format('YYYY-MM-DD') || '' : '';
            }
          },
          {
            title: '项目名称',
            key: 'projectName',
            // dataIndex:'projectName',
            width: '150px',
            customRender: val => {
              if (val.auditDate === 'total') {
                const obj = {
                  attrs: {}
                };
                obj.attrs['colSpan'] = 0;
                return obj;
              }
              return val.projectName;
            }
          }
        ]
      },
      {
        title: '基础信息',
        customHeaderCell: (value, index) => {
          return {
            style: {
              'background-color': '#faf1d0'
            }
          };
        },
        children: [
          {
            title: '项目ID',
            dataIndex: 'projectId',
            key: 'projectId',
            width: '100px'
            // fixed: 'left'
          },
          {
            title: 'DL',
            dataIndex: 'dlName',
            key: 'dlName',
            width: '100px'
          },
          {
            title: '币种',
            dataIndex: 'currency',
            key: 'currency',
            width: '100px',
            customRender: currency => {
              return currencyMap[currency];
            }
          }
        ]
      },
      {
        title: 'DL项目表现汇总表（以北冥为基础，并经业绩调整），可以简称DLPP表（Portfolio Performance）',
        customHeaderCell: (value, index) => {
          return {
            style: {
              'background-color': '#ece2ff'
            }
          };
        },
        children: [
          {
            title: 'Total Cost（CNY）',
            dataIndex: 'totalCostCny',
            key: 'totalCostCny',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `￥${permil(val, 0, true)}` : '';
            }
          },
          {
            title: 'Total Cost（USD）',
            dataIndex: 'totalCostUsd',
            key: 'totalCostUsd',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          },
          {
            title: 'Total Cost合计（USD）',
            dataIndex: 'totalTotalCostUsd',
            key: 'totalTotalCostUsd',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          },
          {
            title: 'Total Return（CNY）',
            key: 'totalReturnCNY',
            align: 'right',
            width: '150px',
            customRender: (val, row, index) => {
              if (val.auditDate === 'total') {
                return `￥${permil(val.totalReturnCny, 0, true)}`;
              }
              let data = +val.realizedProceedsCny + +val.unRealizedFmvCny;
              return data || data === 0 ? `￥${permil(data, 0, true)}` : '';
            }
          },
          {
            title: 'Total Return（USD）',
            key: 'totalReturnUSD',
            align: 'right',
            width: '150px',
            customRender: val => {
              if (val.auditDate === 'total') {
                return `$${permil(val.totalReturnUsd, 0, true)}`;
              }
              let data = +val.realizedProceedsUsd + +val.unRealizedFmvUsd;
              return data || data === 0 ? `$${permil(data, 0, true)}` : '';
            }
          },
          {
            title: 'Total Return合计（USD）',
            key: 'totalTotalReturnUsd',
            dataIndex: 'totalTotalReturnUsd',
            align: 'right',
            width: '150px',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          },
          {
            title: 'MOIC（CNY）',
            key: 'MOICCNY',
            width: '150px',
            align: 'right',
            customRender: val => {
              let tmp = +val.realizedProceedsCny + +val.unRealizedFmvCny;
              let tmp2 = +val.totalCostCny;
              let data = tmp / tmp2;
              if (tmp === 0 && tmp2 === 0) {
                return '0.00';
              } else if (tmp2 === 0 && tmp !== 0) {
                return '';
              } else {
                return data || data === 0 ? permil(data, 2, true) : '';
              }
              // return data || tmp || data === 0 || tmp === 0 ? permil(data, 2, true) : '';
            }
          },
          {
            title: 'MOIC（USD）',
            key: 'MOICUSD',
            width: '150px',
            align: 'right',
            customRender: val => {
              let tmp = +val.realizedProceedsUsd + +val.unRealizedFmvUsd;
              let tmp2 = +val.totalCostUsd;
              let data = tmp / tmp2;
              if (tmp === 0 && tmp2 === 0) {
                return '0.00';
              } else if (tmp2 === 0 && tmp !== 0) {
                return '';
              } else {
                return data || data === 0 ? permil(data, 2, true) : '';
              }
            }
          },
          {
            title: 'MOIC合计',
            key: 'totalMOIC',
            width: '150px',
            align: 'right',
            customRender: val => {
              let tmp = +val.totalTotalReturnUsd;
              let tmp2 = +val.totalTotalCostUsd;
              let data = tmp / tmp2;
              if (tmp === 0 && tmp2 === 0) {
                return '0.00';
              } else if (tmp2 === 0 && tmp !== 0) {
                return '';
              } else {
                return data || data === 0 ? permil(data, 2, true) : '';
              }
            }
          },
          {
            title: '退出成本（CNY）',
            dataIndex: 'realizedCostCny',
            key: 'realizedCostCny',
            align: 'right',
            width: '150px',
            customRender: val => {
              return val || val === 0 ? `￥${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '退出成本（USD）',
            dataIndex: 'realizedCostUsd',
            key: 'realizedCostUsd',
            align: 'right',
            width: '150px',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '退出总收益（CNY）',
            dataIndex: 'realizedProceedsCny',
            key: 'realizedProceedsCny',
            align: 'right',
            width: '150px',
            customRender: val => {
              return val || val === 0 ? `￥${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '退出总收益（USD）',
            dataIndex: 'realizedProceedsUsd',
            key: 'realizedProceedsUsd',
            align: 'right',
            width: '150px',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '未退出部分成本（CNY）',
            dataIndex: 'unRealizedCostCny',
            key: 'unRealizedCostCny',
            align: 'right',
            width: '150px',
            customRender: val => {
              return val || val === 0 ? `￥${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '未退出部分成本（USD）',
            dataIndex: 'unRealizedCostUsd',
            align: 'right',
            key: 'unRealizedCostUsd',
            width: '150px',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '未退出部分FMV（财报口径）（CNY）',
            dataIndex: 'reportUnRealizedFmvCny',
            key: 'reportUnRealizedFmvCny',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `￥${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '未退出部分FMV（财报口径）（USD）',
            dataIndex: 'reportUnRealizedFmvUsd',
            key: 'reportUnRealizedFmvUsd',
            align: 'right',
            width: '150px',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          }
        ]
      },
      {
        title: '原始数据部分（from北冥）',
        customHeaderCell: (value, index) => {
          return {
            style: {
              'background-color': '#fbbfbc'
            }
          };
        },
        children: [
          {
            title: '币种',
            dataIndex: 'currency',
            key: 'currency2',
            width: '150px',
            customRender: currency => {
              return currencyMap[currency];
            }
          },
          {
            title: '股数',
            dataIndex: 'shareNum',
            key: 'shareNum',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? permil(val, 2, true) : '';
            }
          },
          {
            title: '最新一轮每股单价（财报口径）',
            // dataIndex: 'reportValueShareUnitPrice',
            key: 'reportValueShareUnitPrice',
            width: '150px',
            align: 'right',
            customRender: val => {
              let render = '';
              let data = +val.reportValueShareUnitPrice;
              if (data || data === 0) {
                val.valueCurrency === 1 ? (render = `￥${permil(data, 0, true)}`) : (render = `$${permil(data, 0, true)}`);
              }
              return render;
            }
          },
          {
            title: '最新一轮估值（财报口径）',
            // dataIndex: 'reportValuePostValuation',
            key: 'reportValuePostValuation',
            width: '150px',
            align: 'right',
            customRender: val => {
              let render = '';
              let data = +val.reportValuePostValuation;
              if (data || data === 0) {
                val.valueCurrency === 1 ? (render = `￥${permil(data, 0, true)}`) : (render = `$${permil(data, 0, true)}`);
              }
              return render;
            }
          },
          {
            title: '最新一轮每股单价（报告期后）',
            // dataIndex: 'valueShareUnitPrice',
            key: 'valueShareUnitPrice',
            width: '150px',
            align: 'right',
            customRender: val => {
              let render = '';
              let data = +val.valueShareUnitPrice;
              if (data || data === 0) {
                val.valueCurrency === 1 ? (render = `￥${permil(data, 0, true)}`) : (render = `$${permil(data, 0, true)}`);
              }
              return render;
            }
          },
          {
            title: '最新一轮估值（报告期后）',
            // dataIndex: 'valuePostValuation',
            key: 'valuePostValuation',
            width: '150px',
            align: 'right',
            customRender: val => {
              let render = '';
              let data = +val.valuePostValuation;
              if (data || data === 0) {
                val.valueCurrency === 1 ? (render = `￥${permil(data, 0, true)}`) : (render = `$${permil(data, 0, true)}`);
              }
              return render;
            }
          },
          {
            title: '仍持有的股比（CNY）',
            dataIndex: 'remainShareRatioCny',
            key: 'remainShareRatioCny',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? permil(val * 100, 2, true) + '%' : '';
            }
          },
          {
            title: '仍持有的股比（USD）',
            dataIndex: 'remainShareRatioUsd',
            key: 'remainShareRatioUsd',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? permil(val * 100, 2, true) + '%' : '';
            }
          },
          {
            title: 'Total Cost（CNY）',
            // dataIndex: 'totalCostCny',
            key: 'totalCostCny2',
            width: '150px',
            align: 'right',
            customRender: val => {
              if (val.auditDate === 'total') {
                return '';
              }
              return val.totalCostCny || val.totalCostCny === 0 ? `￥${permil(val.totalCostCny, 0, true)}` : '';
            }
          },
          {
            title: 'Total Cost（USD）',
            // dataIndex: 'totalCostUsd',
            key: 'totalCostUsd2',
            width: '150px',
            align: 'right',
            customRender: val => {
              if (val.auditDate === 'total') {
                return '';
              }
              return val.totalCostUsd || val.totalCostUsd === 0 ? `$${permil(val.totalCostUsd, 0, true)}` : '';
            }
          },
          {
            title: '退出成本（CNY）',
            dataIndex: 'realizedCostCny',
            key: 'realizedCostCny2',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `￥${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '退出成本（USD）',
            dataIndex: 'realizedCostUsd',
            key: 'realizedCostUsd2',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '退出总收益（CNY）',
            dataIndex: 'realizedProceedsCny',
            key: 'realizedProceedsCny2',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `￥${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '退出总收益（USD）',
            dataIndex: 'realizedProceedsUsd',
            key: 'realizedProceedsUsd2',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '未退出部分成本（CNY）',
            dataIndex: 'unRealizedCostCny',
            key: 'unRealizedCostCny2',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `￥${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '未退出部分成本（USD）',
            dataIndex: 'unRealizedCostUsd',
            key: 'unRealizedCostUsd2',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '未退出部分FMV（CNY）',
            dataIndex: 'unRealizedFmvCny',
            key: 'unRealizedFmvCny',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `￥${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '未退出部分FMV（USD）',
            dataIndex: 'unRealizedFmvUsd',
            key: 'unRealizedFmvUsd',
            width: '150px',
            align: 'right',
            customRender: val => {
              return val || val === 0 ? `$${permil(val, 0, true)}` : '';
            }
          },
          {
            title: '最近一次估值变化的时间',
            dataIndex: 'valueChangeDate',
            key: 'valueChangeDate',
            // width: '100px',
            customRender: val => {
              return val ? moment(val).format('YYYY-MM-DD') : '';
            }
          }
        ]
      }
    ];
  }

  async getPermission() {
    try {
      let res = await reportList();
      if (res.code === 200) {
        const exportList = res.data.filter(_ => _.id === 1)[0].export.map(_ => _.id);
        const { id } = this.userInfo || {};
        this.hasPermission = exportList.indexOf(id) > -1;
      }
    } catch (err) {
      console.log(err);
    }
  }

  async exportReport() {
    try {
      let date = moment(new Date()).format('YYYYMMDD');
      downloadStreamFile('/dataService/reportForm/investPerformance/download', '', `投资业绩表_${date}`);
    } catch (err) {
      console.log(err);
    }
  }

  handleSearch() {
    this.page = 1;
    this.current = 1;
    this.getList();
  }

  currencyChange(val) {
    this.page = 1;
    this.currency = val;
    this.current = 1;
    this.getList();
  }

  DLChange(val) {
    this.page = 1;
    this.nickName = val;
    this.current = 1;
    this.getList();
  }

  onChange(date, dateString) {
    this.endDate = moment(date).format('YYYYMMDD');
    this.current = 1;
    this.getList();
  }

  changePage(page, pageSiz) {
    this.page = page;
    this.getList();
  }

  onShowSizeChange(current, pageSize) {
    this.pageSize = pageSize;
    this.getList();
  }

  filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  queryList() {
    this.current = 1;
    this.page = 1;
    this.getList();
  }
}

export default INVESTPERFORMANCE;
